import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../intangibleAssetLedgerSlice";
import {
  fetchIntangibleAssetLedger,
  searchIntangibleAccounts,
} from "../intangibleAssetLedgerThunk";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";

const IntangibleAssetLedgerFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters, loadingSearch } = useSelector(
    (state) => state.intangibleAssetLedger
  );

  useDefaultDateRange(setFilters, filters, "today");

  const handleSearch = useCallback(
    (text) => dispatch(searchIntangibleAccounts(text)),
    [dispatch]
  );

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.accId) {
      messageApi.warning("Select an Intangible Asset Account");
      return;
    }
    if (!filters.fromDate || !filters.toDate) {
      messageApi.warning("Select Date Range");
      return;
    }

    dispatch(
      fetchIntangibleAssetLedger({
        accId:    filters.accId,
        fromDate: filters.fromDate,
        toDate:   filters.toDate,
      })
    ).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Ledger loaded ✅");
      } else {
        messageApi.error("Failed to fetch ledger ❌");
      }
    });
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={16} style={{ alignItems: "center" }}>
        <Col span={6}>
          <label>Search Account</label>
          <SearchListAutoComplete
            entityType="intangible_asset"
            searchThunk={handleSearch}
            resultSelector={(state) => state.intangibleAssetLedger.searchResults}
            loading={loadingSearch}
            onSelect={(obj) => {
              if (!obj) {
                handleFilterChange("accId", null);
                handleFilterChange("accName", "");
                return;
              }
              handleFilterChange("accId", obj.acc_id);
              handleFilterChange("accName", obj.acc_name);
            }}
            placeholder="Intangible Asset Account"
            showAddNew={false}
          />
        </Col>

        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
            handleFilterChange("fromDate", fromDate);
            handleFilterChange("toDate", toDate);
          }}
        />

        <Col
          span={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            style={{ height: 35.19 }}
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default IntangibleAssetLedgerFilters;